var Project = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/project',
    editGroupPermission: 'admin_projects',

    initialize: function(attributes, options) {
        if (options && options.urlRoot) this.urlRoot = options.urlRoot;
    },

    defaults: function() {
        return {
            uuid: Core.randomUUID(),
            state: 'PUBLISHED',
            documents: [],
            labels: [],
        };
    },

    emptyTemplate: function() {

    },

    setFromTemplate: function(template, previousTemplate) {

    },

    belongsToGroup: function(groupId) {
        // TODO check for other stuff as well if needed
        return this.get('groupId') == groupId;
    }
});

var Projects = Backbone.Collection.extend({
    model: Project,
    projectsFilterKey: 'projects.filterParams',

    url: function(options) {
        if (!options) options = {};
        if (this.customUrl) return this.customUrl;

        var url;
        var params = {};

        if (!options.lastModified) {
            // states etc
        }

        if (this.searchQuery) {
            url = Core.contextRoot + '/project/search';
            params.q = this.searchQuery;
        } else {
            url = Core.contextRoot + '/project/list' + (this.filterParams.path ? '/' + this.filterParams.path : '');
            if (this.filterParams.path == 'templates') {
                // templates
            } else {
                if (this.filterParams.path == 'user' && this.filterParams.userId) url += '/' + this.filterParams.userId;
                if (options.lastModified) {
                    // states
                    params.modified = options.lastModified;
                } else {
                    if (this.filterParams.includeUntimed) params.untimed = '';
                    if (this.filterParams.from == null || typeof this.filterParams.from == 'undefined') {
                        var fromDate = new Date();
                        fromDate.setHours(0, 0, 0, 0);
                        this.filterParams.from = fromDate.getTime();
                    }
                    params.from = this.filterParams.from;
                    if (this.filterParams.to)
                        params.to = this.filterParams.to;
                    if ('includeCurrent' in this.filterParams) {
                        if (this.filterParams.includeCurrent)
                            params.current = '';
                    } else if (!this.filterParams.from && !this.filterParams.to)
                        params.current = '';
                }
            }
            if (this.filterParams.params) _(params).extend(this.filterParams.params);
        }
        if (this.filterParams.noCache) params.nocache = '';
        if (this.filterParams.limit) params.limit = this.filterParams.limit;
        if (this.filterParams.offset) params.offset = this.filterParams.offset;
        if (this.filterParams.includeItems) params.items = this.filterParams.includeItems;

        var paramsStr = $.param(params);
        if (paramsStr.length > 0) url += '?' + paramsStr;
        return url;
    },

    initialize: function(models, options) {
        this.filterParams = {
            path: 'all',
            states: ['DRAFT', 'SCHEDULED', 'PUBLISHED', 'DELIVERED', 'CANCELED'], // TODO more?
            includeCurrent: true,
            includeUntimed: true,
            from: null,
            to: null,
            userId: null
        };
        if (options && options.url)
            this.customUrl = options.url;
        else if (options && options.filterParams)
            _(this.filterParams).extend(options.filterParams);
        if (!'path' in this.filterParams)
            this.filterParams.path = 'all';
    },

    saveFilter: function() {
        sessionStorage[this.projectsFilterKey] = JSON.stringify(this.filterParams);
    },

    loadFilter: function() {
        this.filterParams = JSON.parse(sessionStorage[jobsFilterKey]);
    },
});

Projects.filterCollection = function(filter, collection) {
    var filter = _(filter).clone();
    if (!filter.list) filter.list = 'all';

    // TODO filter.where

    var filteredCollection = new Jobs(filter.where ? collection.where(filter.where) : collection.models);
    
    // filter out deletes
    filteredCollection.reset(filteredCollection.filter(function(project) {
        return !project.get('deleted');
    }), { silent: true });
    return filteredCollection;
}